import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "slashToLineBreak" })
export class SlashToLineBreak implements PipeTransform {
  transform(value: string): string {
    if (value && typeof value === "string") {
      return value.replace(/\//g, "\n");
    } else {
      return value;
    }
  }
}
